import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../img/logo.svg';
import iso from '../img/iso.svg';
import './Brand.css';

export default ({ type, isLink }) => {
  const brand = {
    logo: logo,
    iso: iso
  }[type];
  const img = <img className={type} src={brand} alt="" />;

  return isLink ? <Link to="/">{img}</Link> : img;
};



// WEBPACK FOOTER //
// ./src/components/Brand.js